export function isMeetingChangeOrganizerResponse(itemClass: string | undefined): boolean {
    return !!(itemClass && itemClass.match(/^ipm\.schedule\.meeting\.changeorganizerresponse/i));
}
